<template>
  <tr class="text-sm font-medium border-t">
    <td class="pl-4 pr-2 sm:pl-6 sm:pr-4 py-8 text-right" colspan="5">
      {{ totalNetAmountForHumans }}
    </td>
    <td class="px-2 sm:px-4 py-8" />
    <td class="px-2 sm:px-4 py-8 text-right">
      {{ totalVatAmountForHumans }}
    </td>
    <td class="px-2 sm:px-4 py-8 text-right">
      {{ totalForHumans }}
    </td>
    <td class="pr-4 pl-2 sm:pr-6 sm:pl-4 py-8" />
  </tr>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    lines: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    totalNetAmount() {
      return this.lines.reduce((total, current) => {
        const { quantity = 1, pricePerUnit = 0 } = current;
        return total + quantity * pricePerUnit;
      }, 0);
    },
    totalNetAmountForHumans() {
      return Numbro(this.totalNetAmount).formatCurrency({ mantissa: 2 });
    },
    totalVatAmount() {
      return this.lines.reduce((total, current) => {
        const { quantity = 1, pricePerUnit = 0, vatRate = 0 } = current;
        return total + quantity * pricePerUnit * vatRate;
      }, 0);
    },
    totalVatAmountForHumans() {
      return Numbro(this.totalVatAmount).formatCurrency({ mantissa: 2 });
    },
    total() {
      const { totalNetAmount = 0, totalVatAmount = 0 } = this;
      return totalNetAmount + totalVatAmount;
    },
    totalForHumans() {
      return Numbro(this.total).formatCurrency({ mantissa: 2 });
    },
  },
};
</script>
